import { render, staticRenderFns } from "./UserPerm.vue?vue&type=template&id=1b73695a&scoped=true"
import script from "./UserPerm.vue?vue&type=script&lang=js"
export * from "./UserPerm.vue?vue&type=script&lang=js"
import style0 from "./UserPerm.vue?vue&type=style&index=0&id=1b73695a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73695a",
  null
  
)

export default component.exports